import React, { useState } from 'react';
import { supabase } from '../services/supabase';
import { Mail, Lock, AlertTriangle } from 'lucide-react';

const LoginScreen = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Domain restriction check
    if (!email.endsWith('@smgba.com')) {
       setError('Access restricted to @smgba.com corporate accounts only.');
       setLoading(false);
       return;
    }

    const { error } = await supabase.auth.signInWithPassword({ email, password });
    
    if (error) {
        setError(error.message);
    } else {
        onLogin(); 
    }
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-slate-100 flex items-center justify-center p-4 z-50">
      <div className="max-w-md w-full bg-white rounded-xl shadow-2xl border border-slate-200 overflow-hidden">
        
        {/* Header Section */}
        <div className="bg-gradient-to-r from-blue-700 to-blue-900 px-6 py-10 text-center">
            <div className="flex justify-center mb-6">
             {/* Logo - Ensure this URL is accessible */}
             <img 
                src="https://smgba.com/misc/images/logos/SMGIconWhite.png" 
                alt="SMG Staff Hub" 
                className="h-20 w-auto object-contain" 
             />
           </div>
           <h2 className="text-2xl font-bold text-white">Staff Hub</h2>
           <p className="text-blue-200 text-sm">Secure Access Portal</p>
        </div>

        {/* Form Section */}
        <div className="p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            
            {/* Error Message */}
            {error && (
                <div className="flex items-center gap-2 text-red-600 text-sm bg-red-50 p-3 rounded-lg border border-red-100">
                    <AlertTriangle className="w-4 h-4 flex-none"/>
                    <span>{error}</span>
                </div>
            )}

            {/* Email Input */}
            <div className="space-y-1">
                <label className="text-xs font-bold text-slate-500 uppercase">Email</label>
                <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400"/>
                    <input 
                        type="email" 
                        placeholder="name@smgba.com" 
                        required 
                        value={email} 
                        onChange={e => setEmail(e.target.value)} 
                        className="w-full pl-9 pr-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    />
                </div>
            </div>

            {/* Password Input */}
            <div className="space-y-1">
                <label className="text-xs font-bold text-slate-500 uppercase">Password</label>
                <div className="relative">
                    <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400"/>
                    <input 
                        type="password" 
                        placeholder="••••••••" 
                        required 
                        value={password} 
                        onChange={e => setPassword(e.target.value)} 
                        className="w-full pl-9 pr-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    />
                </div>
            </div>

            {/* Submit Button */}
            <button 
                type="submit" 
                disabled={loading} 
                className="w-full py-2.5 bg-blue-700 text-white rounded-lg font-bold hover:bg-blue-800 transition-colors shadow-lg disabled:opacity-70 disabled:cursor-not-allowed"
            >
                {loading ? 'Verifying Credentials...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;